const normalizeAdminEmailMailService = (raw: unknown): "smtp" | "mailjet" | undefined => {
    if (typeof raw !== "string") {
        return undefined;
    }
    const normalized = raw.trim().toLowerCase();
    if (normalized === "smtp" || normalized === "mailjet") {
        return normalized;
    }
    return undefined;
};

/** GET /email uses null for empties; coerce once so Zod can stay plain `z.string()` and we do not list "inactive" keys in each schema. */
export const sanitizeEmailConfigFromApi = (c: API.EmailConfig): API.EmailConfig => {
    const mailServiceNormalized = normalizeAdminEmailMailService(c.mailService);

    const smtpPortParsed = Number(c.smtpPort);
    const smtpPortNumber = Number.isFinite(smtpPortParsed) ? smtpPortParsed : 0;

    return {
        ...c,
        mailService: mailServiceNormalized ?? c.mailService,
        senderMail: c.senderMail ?? "",
        senderName: c.senderName ?? "",
        mailjetApiUser: c.mailjetApiUser ?? "",
        mailjetApiPass: c.mailjetApiPass ?? "",
        mailjetHookCredentials: c.mailjetHookCredentials ?? "",
        smtpHost: c.smtpHost ?? "",
        smtpPort: smtpPortNumber,
        smtpUser: c.smtpUser ?? "",
        smtpPassword: c.smtpPassword ?? "",
    };
};
